import React from 'react';
import { Game } from '../Game';

import '../../styles/index.scss';

export const App = () => <Game />;
